






















































import _ from 'lodash';
import { Component, Vue } from 'vue-property-decorator';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms } from '@/const/terms/componentTerms';
import { SetAdFolder as feedbackTerms} from '@/const/terms/feedback/adFolder'
import { SettingConfirm as confirmTerms} from '@/const/terms/feedback/confirm';

import { STATUS } from '@/const/status/index';
import {DefaultOption, TableOptionType} from '@/const/options/DefaultTableOption';
import {
    AdFolderDataType,
    ISearchForm,
    IAdFolderData,
    AdFolderResponse,
} from './types';
import { AxiosError, AxiosResponse } from 'axios';

import Select from '@/components/ElementComponent/Select/index.vue';
import LinkColumn from '@/components/ElementComponent/Column/LinkColumn.vue';
import NumberColumn from '@/components/ElementComponent/Column/NumberColumn.vue';
import DateColumn from '@/components/ElementComponent/Column/DateColumn.vue';
import StatusColumn from '@/components/ElementComponent/Column/StatusColumn.vue';
import SelectAllColumn from '@/components/ElementComponent/Column/SelectAllColumn.vue';

@Component<AdFolder>({
    name: 'AdFolder',
    components: {
        Select,
        LinkColumn,
        NumberColumn,
        DateColumn,
        StatusColumn,
        SelectAllColumn,
    },
})
export default class AdFolder extends Vue {
    private terms = terms;
    private compTerms = ComponentTerms;
    private confirmTerms = confirmTerms;
    
    private tableOptions: TableOptionType = DefaultOption;
    private loading: boolean = false;
    private isUtilsCollapsed: boolean = false;
    private deleteConfirmVisible: boolean = false;

    private filterForm: ISearchForm = { query: '', page: 1, totalPages: 0, sort: null};
    private tableData: AdFolderDataType = [];
    private selectedAdFolders: AdFolderDataType = [];

    private handleSelectionChange(val: AdFolderDataType): void {
        this.selectedAdFolders = val;
    }

    private sortChangeHandler({ column, prop, order }: {column: any, prop: string, order: string}) {
        this.filterForm.sort = prop ? {prop: prop, order: order} : null;
        this.getAdFolderResponseHandler();
    }
    private deleteAdFolders() {
        this.deleteConfirmVisible = false;
        const targetIDs = this.selectedAdFolders.map((item: IAdFolderData) => {
            return item.id;
        })
        if (targetIDs.length === 0) return true;
        this.loading = true;
        this.$http.adserverAPI.post('DeleteCreativeFolder', {
            ids: targetIDs,
        }).then((res: any) => res.data)
            .then((data: {result: boolean}) => {
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.deleteAdFolder.success);
                    this.getAdFolderResponseHandler();
                    return true;
                }
                throw new Error(feedbackTerms.deleteAdFolder.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.deleteAdFolder.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                this.loading = false;
                throw err;
            })
    }
    private getAdFolderResponseHandler() {
        this.loading = true;
        this.selectedAdFolders = [];
        this.getAdFolderResponse().then((res: any) => res.data)
            .then((data: AdFolderResponse) => {
                this.tableData = data.folders;
                this.filterForm.totalPages = data.pages;
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=>{this.loading=false})
    }
    private getAdFolderResponse(){
        this.setRouteQueryFromFilter();
        const sort = this.filterForm.sort && this.filterForm.sort.prop ? `${this.filterForm.sort.order === 'ascending'? '' : '-'}${this.filterForm.sort.prop}` : '';
        return this.$http.adserverAPI.post('GetCreativeFolderSummary', {
            query: this.filterForm.query,
            page_no: this.filterForm.page,
            sort: sort,
        })
    }

    private setRouteQueryFromFilter(){
        const query: {[name: string]: any} = {}
        this.filterForm.query && (query.query = this.filterForm.query);
        this.filterForm.page && (query.page = this.filterForm.page);
        this.filterForm.sort && this.filterForm.sort.prop && this.filterForm.sort.order && (query.sort = `${this.filterForm.sort.order === 'ascending'? '' : '-'}${this.filterForm.sort.prop}`);

        const newQuery = Object.entries(query).reduce((pre: {[name: string]: any}, entry: [string, any]) => {
            const key = entry[0], value = entry[1];
            return {...pre, [key]: encodeURIComponent(value)};
        }, {});
        
        if (!(_.isEqual(newQuery, this.$route.query))) {
            this.$router.replace({
                ...this.$route,
                query: newQuery,
            })
        }
    }
    private setRouteQueryToFilter() {
        const query = Object.entries(this.$route.query).reduce((pre: {[name: string]: any}, entry: [string, any]) => {
            const key = entry[0], value = entry[1];
            return {...pre, [key]: decodeURIComponent(value)};
        }, {}) as any;
        
        query.query !== undefined && (this.filterForm.query = query.query as string);
        query.page !== undefined && (this.filterForm.page = Number.parseInt((query.page as string)));
        query.sort !== undefined && (this.filterForm.sort = (query.sort as string)[0] === '-' ? { 
            order: 'descending', prop: (query.sort as string).slice(1)
        } : {
            order: 'ascending', prop: (query.sort as string)
        });
    }
    private created() {
        this.setRouteQueryToFilter();
    }
    private mounted() {
        this.$nextTick( () => {
            this.getAdFolderResponseHandler();
        });
    }

}
